import { createAsyncThunk } from '@reduxjs/toolkit';
import { BookModel } from '../../interfaces/book.interface';
import { callAPI } from '../../services/api.service';
import { setDraftId } from '../appSlice';
import { setStoryData } from '../storySlice';
import { UserLocalStorageKeysEnum } from '../../interfaces/user.interface';

export const editStory = createAsyncThunk(
  'story/editStory',
  async (params: { propBook: BookModel | null; navigate: (path: string) => void }, { rejectWithValue, dispatch }) => {
    const { propBook, navigate } = params;
    try {
      if (!propBook) {
        throw new Error('Book not found');
      }
      // Make the API call
      const data = await callAPI('api/make-story-draft', {
        email: propBook.email, // If `book.email` is undefined, this will cause an error
        bookId: propBook.id || propBook?.bookId // Similarly, `book.id` or `book?.bookId` could cause issues
      });

      if (data) {
        const currentBookId = localStorage.getItem(UserLocalStorageKeysEnum.BOOK_ID);

        // Handle state updates
        if (currentBookId !== propBook.id) {
          dispatch(setStoryData({ illustrationCharacter: null }));
        }

        // Remove items from local storage
        localStorage.removeItem(UserLocalStorageKeysEnum.BOOK_ID);
        localStorage.removeItem(UserLocalStorageKeysEnum.STORY_STEP);
        localStorage.removeItem(UserLocalStorageKeysEnum.EDIT_MODE);

        // Set draft ID and navigate
        dispatch(setDraftId(data.bookId));
        navigate('/');

        // Return the success result (draftId)
        return data.bookId;
      }

      // In case of no data returned, you may want to throw an error
      throw new Error('No data returned from API');
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  }
);
